<template>
    <div class="fields">
        <div class="row mb-3">
            <div class="col-sm-4 col-md-3">
                <FieldInput
                        v-model="address.fields.postal_code.value"
                        :disabled="address.fields.postal_code.disabled || address.disabled"
                        :error="address.fields.postal_code.error"
                        :data-element="checkDataElement(dataElement + '_postal_code_field')"
                        label="Индекс"
                />
            </div>
            <div class="col-sm-4 col-md-4">
                <FieldSuggests
                        v-model="address.fields.region.value"
                        :disabled="address.fields.region.disabled || address.disabled"
                        :error="address.fields.region.error"
                        :data-element="checkDataElement(dataElement + '_region_field')"
                        label="Область / край"
                        data-type="address"
                        :max-count="5"
                        @select="fillAddressFieldsFromSuggestion"
                />
            </div>
            <div class="col-sm-6 col-md-5">
                <FieldSuggests
                        v-model="address.fields.city.value"
                        :disabled="address.fields.city.disabled || address.disabled"
                        :error="address.fields.city.error"
                        :data-element="checkDataElement(dataElement + '_city_field')"
                        label="Город"
                        data-type="address"
                        :max-count="5"
                        @select="fillAddressFieldsFromSuggestion"
                />
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-sm-12 col-md-6">
                <FieldSuggests
                        v-model="address.fields.street.value"
                        :disabled="address.fields.street.disabled || address.disabled"
                        :error="address.fields.street.error"
                        :data-element="checkDataElement(dataElement + '_street_field')"
                        label="Улица"
                        data-type="address"
                        :max-count="5"
                        @select="fillAddressFieldsFromSuggestion"
                />
            </div>
            <div class="col-sm-12 col-md-2">
                <FieldInput
                        v-model="address.fields.house.value"
                        :disabled="address.fields.house.disabled || address.disabled"
                        :error="address.fields.house.error"
                        :data-element="checkDataElement(dataElement + '_house_field')"
                        label="Дом"
                />
            </div>
            <div class="col-sm-12 col-md-2">
                <FieldInput
                        v-model="address.fields.building.value"
                        :disabled="address.fields.building.disabled || address.disabled"
                        :error="address.fields.building.error"
                        :data-element="checkDataElement(dataElement + '_building_field')"
                        label="Корп. / стр."
                />
            </div>
            <div class="col-sm-12 col-md-2">
                <FieldInput
                        v-model="address.fields.flat.value"
                        :disabled="address.fields.flat.disabled || address.disabled"
                        :error="address.fields.flat.error"
                        :data-element="checkDataElement(dataElement + '_flat_field')"
                        label="Квартира / офис"
                />
            </div>
        </div>
    </div>
</template>

<script>
/* global Mango */
import FieldSuggests from '../../../components/ui/FieldSuggests.vue';
import FieldInput from '../../../components/ui/FieldInput.vue';
import ModelAddress from '../models/address';
import decoder from '../../../lib/decoder';

export default {
    name: "AddressBlock",
    components: {
        FieldInput,
        FieldSuggests,
    },
    props: {
        dataElement: String,
        address: ModelAddress
    },
    methods: {
        checkDataElement(id) {
            return Mango.checkDataElement(id);
        },
        fillAddressFieldsFromSuggestion(data) {
            if (!data) {
                return
            }

            let address = {
                postal_code: decoder.stringValue(data['postal_code'], ''),
                region: [
                    decoder.stringValue(data['region_with_type'], ''),
                    decoder.stringValue(data['area_with_type'], '')].filter(item => item).join(', '),
                city: [
                    decoder.stringValue(data['city_with_type'], ''),
                    decoder.stringValue(data['settlement_with_type'], '')].filter(item => item).join(', '),
                street: decoder.stringValue(data['street_with_type'], ''),
                house: decoder.stringValue(data['house'], ''),
                building: [
                    decoder.stringValue(data['block_type'], ''),
                    decoder.stringValue(data['block'], '')].filter(item => item).join(', '),
                flat: decoder.stringValue(data['flat'], '')
            };

            this.$nextTick(() => {
                for (let key in address) {
                    if (Object.hasOwnProperty.call(address, key) && address[key] !== '' && !this.address.fields[key].disabled ) {
                        this.address.fields[key].value = address[key]
                    }
                }
            });
        }
    }
}
</script>

<style scoped>

</style>